import React, { useEffect, useState } from 'react';
import {
    Box, Typography, Paper, Table, TableHead, TableRow,
    TableCell, TableBody, Button, TextField, Stack, Chip,
    TableContainer
} from '@mui/material';
import api from '../../api/axios';

const ManagerMissedPunchApproval = () => {
    const [requests, setRequests] = useState([]);
    const [remarks, setRemarks] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const loadRequests = async () => {
        try {
            setLoading(true);
            setError('');
            const res = await api.get('/missed-punch/manager');
            setRequests(res.data || []);
        } catch (err) {
            console.error(err);
            setError('Failed to load missed punch approvals');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { loadRequests(); }, []);

    const approve = async (id) => {
        try {
            await api.post(`/missed-punch/manager/approve/${id}?remarks=${encodeURIComponent(remarks[id] || '')}`);
            loadRequests();
        } catch (err) {
            console.error(err);
            alert('Approve failed: ' + (err?.response?.data?.message || err.message));
        }
    };

    const reject = async (id) => {
        try {
            await api.post(`/missed-punch/manager/reject/${id}?remarks=${encodeURIComponent(remarks[id] || '')}`);
            loadRequests();
        } catch (err) {
            console.error(err);
            alert('Reject failed: ' + (err?.response?.data?.message || err.message));
        }
    };

    return (
        <Box sx={{ p: 2, width: '100%' }}>
            <Typography variant="h5" fontWeight={800} mb={3}>
                Missed Punch Approvals (Manager)
            </Typography>

            {error && (
                <Paper sx={{ p: 2, mb: 2, backgroundColor: '#fee2e2', color: '#991b1b' }}>
                    {error}
                </Paper>
            )}

            <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
                <Table>
                    <TableHead sx={{ backgroundColor: '#f1f5f9' }}>
                        <TableRow>
                            <TableCell><b>Employee</b></TableCell>
                            <TableCell><b>Date</b></TableCell>
                            <TableCell><b>Punch Type</b></TableCell>
                            <TableCell><b>Clock In</b></TableCell>
                            <TableCell><b>Clock Out</b></TableCell>
                            <TableCell><b>Reason</b></TableCell>
                            <TableCell><b>Status</b></TableCell>
                            <TableCell><b>Remarks</b></TableCell>
                            <TableCell><b>Action</b></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {loading ? (
                            <TableRow>
                                <TableCell colSpan={9} align="center">Loading...</TableCell>
                            </TableRow>
                        ) : requests.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={9} align="center">No pending requests</TableCell>
                            </TableRow>
                        ) : (
                            requests.map((r) => (
                                <TableRow key={r.attendanceId} hover>
                                    <TableCell>{r.employeeName}</TableCell>
                                    <TableCell>{r.date}</TableCell>
                                    <TableCell>
                                        <Chip label={r.punchType || '-'} size="small" variant="outlined" />
                                    </TableCell>
                                    <TableCell>{r.requestedClockIn || '-'}</TableCell>
                                    <TableCell>{r.requestedClockOut || '-'}</TableCell>
                                    <TableCell>{r.reason}</TableCell>
                                    <TableCell>
                                        <Chip
                                            label={r.status}
                                            size="small"
                                            color={r.status === 'PENDING' ? 'warning' : 'success'}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            size="small"
                                            placeholder="Remarks"
                                            sx={{ width: 150 }}
                                            onChange={(e) =>
                                                setRemarks(prev => ({
                                                    ...prev,
                                                    [r.attendanceId]: e.target.value
                                                }))
                                            }
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Stack direction="row" spacing={1}>
                                            <Button variant="contained" color="success" size="small"
                                                onClick={() => approve(r.attendanceId)}>
                                                Approve
                                            </Button>
                                            <Button variant="contained" color="error" size="small"
                                                onClick={() => reject(r.attendanceId)}>
                                                Reject
                                            </Button>
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default ManagerMissedPunchApproval;